import type { IAnalyticMetric } from '~/types/metric';
import type { DeviceStats } from '~/types/graphql';

import { mapBarChartDataSeries } from '../../helpers';
import { capitalizeFirstLetter } from '~/utils';

export const useDeviceDataSeries = () => {
  const defaultDevices: DeviceStats[] = [
    { totalCount: 0, type: 'mobile' },
    { totalCount: 0, type: 'tablet' },
    { totalCount: 0, type: 'desktop' },
  ];

  const mapDeviceData = (metric?: IAnalyticMetric) => {
    const mergedDevices = defaultDevices.map((defaultDevice) => {
      const matchedDevice = metric?.devices?.find((device) => device?.type === defaultDevice.type);
      return {
        ...defaultDevice,
        totalCount: matchedDevice ? matchedDevice.totalCount : defaultDevice.totalCount,
      };
    });

    return mapBarChartDataSeries<DeviceStats>(mergedDevices, capitalizeFirstLetter);
  };

  return { mapDeviceData };
};
